import React, { ReactNode } from 'react';

import { Theme, useMediaQuery } from '@mui/material';
import { ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

export type ReportPieChartItem = {
  label: ReactNode;
  labelValue?: ReactNode;
  value: number;
  color: string;
};

type Props = {
  data: ReportPieChartItem[];
  disableAnimation?: boolean;
  size?: 'small' | 'default';
};

export const ReportPieChart = ({
  data,
  disableAnimation,
  size = 'default',
}: Props) => {
  const sm =
    size === 'default' &&
    useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
        <Pie
          dataKey="value"
          data={data}
          innerRadius={sm ? 75 : 50}
          outerRadius={sm ? 100 : 70}
          isAnimationActive={disableAnimation ? false : true}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};
